<script setup lang="ts">
defineProps<{ vacancyTypeName: string }>()
const { t } = useI18n({ useScope: 'local' })
</script>

<template>
  <BaseMessage
    class="mt-4"
    type="warning"
    icon
  >
    {{
      t('fullMessage', {
        vacancyTypeName: vacancyTypeName,
      })
    }}
  </BaseMessage>
</template>

<i18n lang="json">
{
  "en": {
    "fullMessage": "Unfortunately, this {vacancyTypeName} is already full! You can no longer apply."
  },
  "nl": {
    "fullMessage": "Helaas, deze {vacancyTypeName} is al vol! Aanmelden is niet meer mogelijk."
  }
}
</i18n>
